import { render, staticRenderFns } from "./RecalcVehicleBenefits.vue?vue&type=template&id=ff3cc3aa&scoped=true"
import script from "./RecalcVehicleBenefits.vue?vue&type=script&lang=js"
export * from "./RecalcVehicleBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3cc3aa",
  null
  
)

export default component.exports